import React from 'react';
import '../DataCollectionGroupPanel.css';
import _ from 'lodash';
import { rank } from '../../../../helpers/Mx/AutoprocessingRank.js';
import AutoProcIntegrationSection from './AutoprocIntegrationSection.js';
import ScreeningSection from './ScreeningSection.js';
import '../DataCollectionGroupPanel.css';
import {  convertToFixed } from '../../../../helpers/NumericTransformationsHelper.js';

export default class ThirdSectionPanel extends React.Component {  
    getArrayValue(array, index){   
        if (array){     
            try{
                return array.split(",")[index].trim();
            }
            catch(e){
                return null;
            }
        }

    }

    getAnomalousArrayValue(array, index){
        var anomalous = this.getArrayValue(array, index);
        if (anomalous === 0){
            return false;
        }
        if (anomalous === 1){
            return true;
        }
        return null;

    }

    /*
        anomalousList = {this.props.anomalousList}
        processingStatus = {this.props.processingStatus}
        processingPrograms = {this.props.processingPrograms}
        processingProgramIds = {this.props.processingProgramIds}
        spaceGroups = {this.props.spaceGroups}
        scalingStatisticsTypes = {this.props.scalingStatisticsTypes} 
        rMerges = {this.props.rMerges} 
        completenessList = {this.props.completenessList}
        resolutionsLimitHigh = {this.props.resolutionsLimitHigh}
        resolutionsLimitLow = {this.props.resolutionsLimitLow}
        cells_a = {this.props.cells_a} 
        cells_b = {this.props.cells_b} 
        cells_c = {this.props.cells_c} 
        cells_alpha = {this.props.cells_alpha} 
        cells_beta = {this.props.cells_beta} 
        cells_gamma = {this.props.cells_gamma} 
    */
    parseResults(){
        var results = [];
        if (this.props.processingProgramIds){            
            /** in this array each program is triple because of inner, overall and outer shells */
            let programIds = this.props.processingProgramIds.split(",");

            /** statisticsTypePrograms will contain every entry for type of shell and program */
            var statisticsTypePrograms = [];
            /** Creating container for programs */

            
            for (var i = 0; i < programIds.length; i++){
                statisticsTypePrograms.push({
                    programId                                           : programIds[i].trim(),
                    v_datacollection_processingStatus                   : this.getArrayValue(this.props.processingStatus, i),
                    processingProgram                                   : this.getArrayValue(this.props.processingPrograms, i),
                    processingProgramId                                 : this.getArrayValue(this.props.processingProgramIds, i),
                    scalingStatisticsType                               : this.getArrayValue(this.props.scalingStatisticsTypes, i),
                    rMerge                                              : convertToFixed(this.getArrayValue(this.props.rMerges, i), 1),
                    completeness                                        : convertToFixed(this.getArrayValue(this.props.completenessList, i), 1),
                    resolutionLimitHigh                                 : convertToFixed(this.getArrayValue(this.props.resolutionsLimitHigh, i), 1),
                    resolutionLimitLow                                  : convertToFixed(this.getArrayValue(this.props.resolutionsLimitLow, i), 1),
                    cell_a                                              : convertToFixed(this.getArrayValue(this.props.cells_a, i),1),
                    cell_b                                              : convertToFixed(this.getArrayValue(this.props.cells_b, i),1),
                    cell_c                                              : convertToFixed(this.getArrayValue(this.props.cells_c, i),1),
                    cell_alpha                                          : convertToFixed(this.getArrayValue(this.props.cells_alpha, i),1),
                    cell_beta                                           : convertToFixed(this.getArrayValue(this.props.cells_beta, i),1),
                    cell_gamma                                          : convertToFixed(this.getArrayValue(this.props.cells_gamma, i),1),
                    v_datacollection_summary_phasing_anomalous          : this.getAnomalousArrayValue(this.props.anomalousList, i),
                    v_datacollection_summary_phasing_autoproc_space_group          : this.getArrayValue(this.props.spaceGroups, i)

                });                
            }

            var groupedByProgramId = _.groupBy(statisticsTypePrograms, "programId");
            var scalingStatisticsTypes = _.uniq(_.map(statisticsTypePrograms,"scalingStatisticsType"));
            for (var programId in groupedByProgramId){
                try{
                    var keyByScalingStatisticsType = _.keyBy(_.groupBy(statisticsTypePrograms, "programId")[programId],"scalingStatisticsType");                
                    results.push(keyByScalingStatisticsType);         
                    try{                        
                        results[results.length-1].programId = keyByScalingStatisticsType[scalingStatisticsTypes[0]]["programId"];
                        results[results.length-1].v_datacollection_processingStatus = keyByScalingStatisticsType[scalingStatisticsTypes[0]]["v_datacollection_processingStatus"];
                        results[results.length-1].processingProgram = keyByScalingStatisticsType[scalingStatisticsTypes[0]]["processingProgram"];
                        results[results.length-1].processingProgramId = keyByScalingStatisticsType[scalingStatisticsTypes[0]]["processingProgramId"];
                        results[results.length-1].v_datacollection_summary_phasing_anomalous = keyByScalingStatisticsType[scalingStatisticsTypes[0]]["v_datacollection_summary_phasing_anomalous"];
                        results[results.length-1].v_datacollection_summary_phasing_autoproc_space_group = keyByScalingStatisticsType[scalingStatisticsTypes[0]]["v_datacollection_summary_phasing_autoproc_space_group"];
                    }
                    catch(e){
                        console.log(e);    
                    }
                }
                catch(e){
                    console.log(e);
                }
            }                     
        }            
        return results;
    }

    getBestResult(){
        var sorted =  rank(this.parseResults());
        if (sorted.length > 0){            
            return sorted[0];
        }
    }

            
    render() {                              
        var bestResult = this.getBestResult(); 
               
        if (bestResult){
            return <AutoProcIntegrationSection bestResult={bestResult}></AutoProcIntegrationSection>;           
        }
        return <ScreeningSection 
                                        ScreeningOutput_indexingSuccess = {this.props.ScreeningOutput_indexingSuccess} 
                                        ScreeningOutput_mosaicity = {this.props.ScreeningOutput_mosaicity} 
                                        ScreeningOutput_strategySuccess = {this.props.ScreeningOutput_strategySuccess} 
                                        summary_datacollection_success = {this.props.summary_datacollection_success} 
                                        ScreeningOutputLattice_spaceGroup = {this.props.ScreeningOutputLattice_spaceGroup} 
                                        ScreeningOutput_rankingResolution = {this.props.ScreeningOutput_rankingResolution} 
                                        ScreeningStrategySubWedge_axisStart = {this.props.ScreeningStrategySubWedge_axisStart} 
                                        ScreeningOutput_totalRotationRange = {this.props.ScreeningOutput_totalRotationRange} 
                                        ScreeningStrategySubWedge_numberOfImages = {this.props.ScreeningStrategySubWedge_numberOfImages} 
                                        ScreeningStrategySubWedge_oscillationRange = {this.props.ScreeningStrategySubWedge_oscillationRange} 
                                        ScreeningStrategySubWedge_transmission = {this.props.ScreeningStrategySubWedge_transmission} 
                                        ScreeningStrategySubWedge_exposureTime = {this.props.ScreeningStrategySubWedge_exposureTime} 
                                        ScreeningOutputLattice_unitCell_a = {this.props.ScreeningOutputLattice_unitCell_a} 
                                        ScreeningOutputLattice_unitCell_b = {this.props.ScreeningOutputLattice_unitCell_b} 
                                        ScreeningOutputLattice_unitCell_c = {this.props.ScreeningOutputLattice_unitCell_c} 
                                        ScreeningOutputLattice_unitCell_alpha = {this.props.ScreeningOutputLattice_unitCell_alpha} 
                                        ScreeningOutputLattice_unitCell_beta = {this.props.ScreeningOutputLattice_unitCell_beta} 
                                        ScreeningOutputLattice_unitCell_gamma = {this.props.ScreeningOutputLattice_unitCell_gamma} 
            ></ScreeningSection>;           
    }
}





// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/SummaryDataCollectionGroup/ThirdSectionPanel.js